export default {
  inserted(el) {
    if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
      el.name =
        el.name +
        Math.random()
          .toString(36)
          .substring(2);
      el.setAttribute("autocomplete", "new-" + el.name.toString());
      el.addEventListener("contextmenu", blockEvent);
    }
  }
};

function blockEvent(e) {
  e.preventDefault();
}



// WEBPACK FOOTER //
// ./src/components/utils/disable-autofill/disable-autofill.js